export type DocumentCategory =
  | 'helping-hands'
  | 'mpap'
  | 'equifax'
  | 'user-upload'
  | 'other';

export interface ClientDocument {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  category: DocumentCategory;
  uploadedBy: string;
  uploadedAt: string;
  downloadUrl?: string;
}

export interface ClientDocumentsState {
  documents: ClientDocument[];
}
